import { render, staticRenderFns } from "./backButton.vue?vue&type=template&id=ce9be186&"
import script from "./backButton.vue?vue&type=script&lang=js&"
export * from "./backButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce9be186')) {
      api.createRecord('ce9be186', component.options)
    } else {
      api.reload('ce9be186', component.options)
    }
    module.hot.accept("./backButton.vue?vue&type=template&id=ce9be186&", function () {
      api.rerender('ce9be186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/backButton.vue"
export default component.exports